import type { TGetLeadsRepresadosParams } from '../http/get-leads-represados.service'

export const leadsRepresadosQueryKeys = {
  leadsRepresados: (query: Partial<TGetLeadsRepresadosParams>) => ['clientes', 'leadsRepresados', query] as const,
  leadRepresadoPorId: (id: string) => ['clientes', 'leadRepresado', id] as const,
  documentosLead: (clienteId: string) => ['clientes', 'leadRepresado', clienteId, 'documentos'] as const,
  envioDocumentosLead: () => ['clientes', 'leadRepresado', 'envioDocumentos'] as const,
}
